import { render } from "./DashboardPredictiveAnalyticsContributionsModal.vue?vue&type=template&id=4fca442b"
import script from "./DashboardPredictiveAnalyticsContributionsModal.vue?vue&type=script&lang=js"
export * from "./DashboardPredictiveAnalyticsContributionsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__